export function getUniqueTypeSubtypePairs(data) {
  const map = new Map();

  data.forEach((obj) => {
    const eventType = obj.eventType ?? obj.event_type;
    const subtype = obj.subtype ?? "";
    const intakeOutcomeType = obj.intakeOutcomeType ?? obj.intake_outcome_type;
    const key = `${eventType}=${subtype}`;

    const existing = map.get(key);
    const currentCategory = extractSacCategory(intakeOutcomeType);

    if (!existing || (existing.sacCategory === "null" && currentCategory)) {
      map.set(key, {
        type: eventType,
        subtype: subtype === "" ? "null" : subtype,
        key,
        sacCategory: currentCategory || "null",
      });
    }
  });

  return Array.from(map.values());
}

export const intakeCategories = [
  {
    name: "Stray at Large",
    value: "stray_at_large_count",
  },
  {
    name: "Relinquished by Owner",
    value: "relinquished_by_owner_count",
  },
  {
    name: "Owner Intended Euthanasia",
    value: "owner_intended_euthanasia_count",
  },
  {
    name: "Transferred In State",
    value: "transferred_instate_in_from_agency_count",
  },
  {
    name: "Transferred Out of State",
    value: "transferred_out_of_state_in_from_agency_count",
  },
  {
    name: "Transferred Internationally",
    value: "transferred_internationally_in_from_agency_count",
  },
  {
    name: "Transferred Undesignated",
    value: "legacy_transferred_in_from_agency_count",
  },
  {
    name: "Seized or Impounded",
    value: "seized_or_impounded_count",
  },
  {
    name: "Other Intakes",
    value: "other_intakes_count",
  },
  {
    name: "Do not include",
    value: "do_not_include",
  },
];

export const outcomeCategories = [
  {
    name: "Adoption",
    value: "adoption_count",
  },
  {
    name: "Return to Owner",
    value: "returned_to_owner_count",
  },
  {
    name: "Return to field",
    value: "returned_to_field_count",
  },
  {
    name: "Transferred In State",
    value: "transferred_instate_to_another_agency_count",
  },
  {
    name: "Transferred Out of State",
    value: "transferred_out_of_state_to_another_agency_count",
  },
  {
    name: "Transferred Internationally",
    value: "transferred_internationally_to_another_agency_count",
  },
  {
    name: "Transferred Undesignated",
    value: "legacy_transferred_to_another_agency_count",
  },
  {
    name: "Shelter Euthanasia",
    value: "shelter_euthanasia_count",
  },
  {
    name: "Died in Care",
    value: "died_in_care_count",
  },
  {
    name: "Lost in Care",
    value: "lost_in_care_count",
  },
  {
    name: "Owner Intended Euthanasia",
    value: "owner_intended_euthanasia_count",
  },
  {
    name: "Other Live Outcomes",
    value: "other_live_outcomes",
  },
  {
    name: "Do not include",
    value: "do_not_include",
  },
];

function extractSacCategory(inputString) {
  if (!inputString || inputString === "null") {
    return null;
  }

  return inputString;
}
